import { useEffect } from "react";

const useScript = (url: string, options?: { async?: boolean, crossOrigin?: boolean }) => {
  useEffect(() => {
    const script = document.createElement("script");

    script.src = url;
    script.async = options?.async ?? true;
    if (options?.crossOrigin) {
      script.crossOrigin = "";
    }

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [url]);
};

export default useScript;
